import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * Returns whether the Plain support chat launcher should be shown.
 *
 * Defaults to `false`. The launcher also needs `VITE_PLAIN_APP_ID` set in the environment.
 */
function useShowPlainChat(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.PLAIN_CHAT, false);
}

export { useShowPlainChat };
